import { render } from "./FilosofiaPage.vue?vue&type=template&id=35732d54"
import script from "./FilosofiaPage.vue?vue&type=script&lang=js"
export * from "./FilosofiaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__